import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VoucherDetailPageRoutingModule } from './voucher-detail-routing.module';

import { VoucherDetailPage } from './voucher-detail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VoucherDetailPageRoutingModule
  ],
  declarations: [VoucherDetailPage]
})
export class VoucherDetailPageModule {}
